export default "__VITE_ASSET__f048729f__"